import { Hero } from "../components/home/Hero";
import { Stats } from "../components/home/Stats";
import { ServicesGrid } from "../components/home/ServicesGrid";
import { TrustBanner } from "../components/home/TrustBanner";
import { Process } from "../components/home/Process";
import { Testimonials } from "../components/home/Testimonials";
import { CtaPopup } from "../components/lead/CtaPopup";
import { useLeadModal } from "../context/LeadModalContext";
import { Button } from "../components/ui/button";
import { ArrowRight } from "lucide-react";

export default function Home() {
	const { openLeadModal } = useLeadModal();
	return (
		<div>
			<Hero />
			<Stats />
			<ServicesGrid />
			<TrustBanner />
			<Process />
			<Testimonials />

			<section className="py-16 md:py-24">
				<div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
					<div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-slate-900 to-emerald-950 p-8 sm:p-12 text-center">
						<div className="absolute inset-0 bg-grid opacity-40" />
						<div className="relative">
							<h2 className="font-heading text-3xl sm:text-4xl font-extrabold text-white">
								Ready to fill every seat?
							</h2>
							<p className="mt-4 text-lg text-slate-300 max-w-xl mx-auto">
								Book a free growth consultation. Our experts will map your school's path to more admissions.
							</p>
							<Button
								onClick={() => openLeadModal({ sourcePage: "Homepage" })}
								className="mt-8 rounded-full bg-emerald-600 hover:bg-emerald-500 text-white px-8 py-6 text-base font-semibold"
							>
								GET MY FREE CONSULTATION <ArrowRight className="ml-2 h-5 w-5" />
							</Button>
						</div>
					</div>
				</div>
			</section>

			<CtaPopup />
		</div>
	);
}
